import type { FaireProductEntity } from "../../entity_types/product";

export const p_spu93nyfnu: FaireProductEntity = {
  token: "p_spu93nyfnu",
  type: "product",
  name: "garden flowers notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/fc9c849b616bff9a621b693d78ae3fa3e98a9285237a5e37e6749892fa0af92e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84c3da48fb3fde795a13fbdf1d24dcd33e0bf066ac06a41dd54013552bed87d3.jpeg",
  ],
  priceDollars: 8,
  description:
    'Send sweet greetings to your loved ones. The garden flower notecards are blank on the inside with charming watercolor illustration of favorite garden flowers on the front. Included in the illustration are: hydrangea, tulip, daisy, delphinium, garden rose, dahlia, daffodil, violet, and ranunculus. They bring a touch of beauty to your thank-you notes, housewarming gifts, get-well wishes, and more.\n\nDetails:\n\n- set of eight folded cards + envelopes\n- blank inside\n- 5.5" x 4.25"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:47.223Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
